<template>
<v-form ref="form" v-model="valid" v-on:submit="save">
  <v-flex xs8>
    <v-text-field v-model="name" :rules="nameRules" :label="`${$t('related.name')}`" required></v-text-field>
  </v-flex>
  <div>
    <h3> {{ $t('dir.schemas') }} : </h3>
    <div :key="index" v-for="(keyName, index) in keysSchemasId">
      <v-layout>
        <v-flex xs5 sm3>
          <v-select :rules="schemaRule" v-model="keysSchemasId[index]" :items="schemas" :label="`${$t('stats.schema')}`" item-text="name" item-value="id">
          </v-select>
        </v-flex>
        <v-flex xs2 sm1>
          <v-btn v-if="index!=0" style="margin-left:2rem;" fab small block @click="keysSchemasId.splice(index,1)">
            <v-icon small>remove</v-icon>
          </v-btn>
        </v-flex>
        <v-flex v-if="index>=keysSchemasId.length-1" xs2 sm2>
          <v-btn fab small @click="keysSchemasId.push('')">
            <v-icon small>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
  <v-btn type="submit">
    {{ $t('archive.filter.save') }}
  </v-btn>
</v-form>
</template>
<script>
export default {
  components: {},
  props: ['dirView', 'schemas'],
  data() {
    return {
      name: "",
      valid: false,
      nameRules: [
        v => !!v || this.$t('validator.blank'),
        v => !!v && (v.length <= 100 && v.length > 2) || this.$t('validator.wrong_length'),
      ],
      schemaRule: [
        v => !!v && v > 0 || this.$t('validator.blank')
      ],
      keysSchemasId: [""]
    }
  },
  created() {
    if (this.dirView != undefined) {
      this.keysSchemasId = this.dirView.schemas.map(schema => schema.id)
      this.name = this.dirView.name
    }
  },
  methods: {
    save(e) {
      e.preventDefault();
      if (this.$refs.form.validate() && this.valid) {
        this.$emit("saved", this.getPayload())
      }
    },
    resetForm() {
      this.$refs.form.reset()
    },
    getPayload() {
      let payload = {}
      payload.name = this.name
      payload.schemas = this.keysSchemasId
      if (this.dirView != undefined) {
        payload.id = this.dirView.id
      }

      return payload;
    }
  },
}
</script>

<style>
.loading-circle {
  margin: 20px;
}
</style>
